import { collection, addDoc, getDocs, deleteDoc, doc, query, orderBy, limit } from "firebase/firestore";
import { db } from "./firebase-config";

// Path: users/{userId}/transactions/{docId}
export const addTransaction = async (uid, transaction) => {
  const ref = collection(db, 'users', uid, 'transactions');
  await addDoc(ref, transaction);
};

export const getTransactions = async (uid, opts = {}) => {
  const ref = collection(db, 'users', uid, 'transactions');
  let q = ref;
  if (opts.recent) {
    q = query(ref, orderBy('date', 'desc'), limit(opts.recent));
  }
  const snap = await getDocs(q);
  return snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const deleteTransaction = async (uid, transactionId) => {
  const ref = doc(db, 'users', uid, 'transactions', transactionId);
  await deleteDoc(ref);
};

// Example transaction:
// { amount, date, description, categoryId }
